import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-filtro-fecha',
  templateUrl: './filtro-fecha.component.html',
  styleUrls: ['./filtro-fecha.component.scss']
})
export class FiltroFechaComponent implements OnInit {

  @Input() empresas_checked: any
  @Input() map: any

  constructor() { }

  start_date: Date ;
  end_date: Date;
  max_date: Date;
  min_date: Date;

  ngOnInit() {
    this.max_date = new Date(Date.now())
  }

  limpiarfechas(){
    this.start_date = this.end_date = null
    this.map.getLayers().forEach(lyr => {
      if(lyr && lyr.get('name') != 'CapaBase'){
        var filterstring = "id_empresa IN ("+this.empresas_checked+")";
        console.log(filterstring);
        console.log(lyr);
        lyr.get('source').updateParams({'cql_filter': filterstring});
        lyr.get('source').updateParams({"time": Date.now()});
      }
    })
    document.getElementById('limpiar_fechas').style.display = "none";
  }

  FiltroFechas(){
    setTimeout(()=>{
      if(this.end_date){
        this.max_date = this.end_date
      }
      if(this.start_date){
        this.min_date = this.start_date
      }
      if(this.empresas_checked.length == 0){
        alert('Seleccione primero las empresas y capas que desea filtrar')
      }
      else{
        if(this.start_date && this.end_date){
          document.getElementById('limpiar_fechas').style.display = "block";
          var startmonth = this.start_date.getMonth() + 1;
          const start_date = startmonth +"/"+ this.start_date.getDate() + "/" + this.start_date.getFullYear();
          var endmonth = this.end_date.getMonth() + 1;
          const end_date = endmonth  +"/" + this.end_date.getDate() + "/" +this.end_date.getFullYear();
          this.map.getLayers().forEach(lyr => {
            if(lyr && lyr.get('name') != 'CapaBase'){
              var filterstring = "id_empresa IN ("+this.empresas_checked+")"+"AND fecha >= '"+start_date+"' AND fecha <= '"+ end_date +"'";
              lyr.get('source').updateParams({'cql_filter': filterstring});
              lyr.get('source').updateParams({"time": Date.now()});
            }
          });
        }
      }
    })
  }
}
